import { io } from 'socket.io-client'

// Dev falls back to localhost; production must set BASEURL (empty here → new URL throws loudly
// rather than silently connecting sockets to localhost in prod).
const baseUrl = process.env.BASEURL || (process.env.NODE_ENV !== 'production' ? 'http://localhost:3333' : '')
const SOCKET_URL = new URL(baseUrl).origin

class Socket {
    private socket: any

    constructor() {
        this.socket = null
    }

    getSocket() {
        if (!this.socket || this.socket.disconnected) {
            this.socket = io(SOCKET_URL)
        }
        return this.socket
    }

    subscribe(event, handler) {
        // register the handler directly (no wrapper) so unsubscribe can match it
        this.getSocket().on(event, handler)
    }

    unsubscribe(event, handler) {
        if (this.socket) {
            this.socket.off(event, handler)
        }
    }

    emit(event, msg) {
        this.getSocket().emit(event, msg)
    }

    close() {
        if (this.socket && this.socket.connected) {
            this.socket.close()
        }
    }
}

export default new Socket()
